import React, { useState, useEffect } from "react";
import { Analytics } from "@vercel/analytics/react"
import Typewriter from "typewriter-effect";
import skills from "./skills";
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";

function App() {
  return (
    <div className="bg-black font-Kanit">
<Analytics />

      <Header />

      <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        <div class="mt-36 md:mt-16 md:grid md:grid-cols-2 md:items-center md:gap-12 xl:gap-32">
          <div className="animate-fade-right animate-once animate-duration-1000 animate-ease-linear">
            <img
              className="hidden md:flex rounded-full mx-auto w-80 h-80 object-cover"
              src="/assets/img/pic2.jpeg"
              alt="profile"
            />
          </div>

          <div class="mt-6 lg:mt-0">
            <div class="space-y-6 sm:space-y-8">
              <div class="space-y-2 md:space-y-4 animate-fade-down md:animate-fade-left animate-once animate-ease-linear">
                <h1 class="text-white font-Edu text-center md:text-left text-4xl mt-12 md:mt-5 md:text-6xl lg:text-5xl">
                  Hey, <span>👋</span>
                </h1>
                <h1 className="text-center text-4xl md:text-left bg-gradient-to-r from-pink-500 to-orange-500 text-transparent bg-clip-text md:text-left font-bold font-Edu md:text-6xl">
                  I'm Ashish
                </h1>
                <h2 className="text-center mb-12 font-Edu text-xl md:text-left bg-gradient-to-r from-gray-100 to-gray-300 text-transparent bg-clip-text md:text-left md:text-3xl font-bold md:mt-1">
                  <Typewriter
                    options={{
                      strings: [
                        "AWS Certified Solutions Architect",
                        "A Full Stack Web Developer",
                        "A Cloud Enthusiast",
                      ],
                      autoStart: true,
                      loop: true,
                      skipAddStyles: false,
                    }}
                  />
                </h2>
                <div className="grid  h-16 place-items-center">
                  <div className="mt-2 flex md:hidden space-x-4">
                  <a target="_blank" rel="noreferrer" href="https://github.com/Ashish4793">
                <div className="group relative inline-block">
                  <img
                    alt="Github"
                    loading="lazy"
                    width={48}
                    height={48}
                    decoding="async"
                    data-nimg={1}
                    className="w-8"
                    style={{ color: "transparent" }}
                    src="../assets/img/social/github-fill.svg"
                  />
                  <p className="invisible absolute whitespace-nowrap rounded-md bg-neutral-900 p-2 text-xs text-white opacity-0 shadow-sm duration-100 ease-linear group-hover:visible group-hover:opacity-100 left-1/2 top-full mt-2 -translate-x-1/2 false false false">
                    Github
                  </p>
                </div>
              </a>

              <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/ashishk4793">
                <div className="group relative inline-block">
                  <img
                    alt="Linkedin"
                    loading="lazy"
                    width={48}
                    height={48}
                    decoding="async"
                    data-nimg={1}
                    className="w-8"
                    style={{ color: "transparent" }}
                    src="../assets/img/social/linkedin.svg"
                  />
                  <p className="invisible absolute whitespace-nowrap rounded-md bg-neutral-900 text-white p-2 text-xs opacity-0 shadow-sm duration-100 ease-linear group-hover:visible group-hover:opacity-100 left-1/2 top-full mt-2 -translate-x-1/2 false false false">
                    Linkedin
                  </p>
                </div>
              </a>
              <a target="_blank" rel="noreferrer" href="https://twitter.com/AshishK4793">
                <div className="group relative inline-block">
                  <img
                    alt="x"
                    loading="lazy"
                    width={42}
                    height={42}
                    decoding="async"
                    data-nimg={1}
                    className="w-7"
                    style={{ color: "transparent" }}
                    src="../assets/img/social/twitter.svg"
                  />
                  <p className="invisible absolute whitespace-nowrap rounded-md bg-neutral-900 text-white p-2 text-xs opacity-0 shadow-sm duration-100 ease-linear group-hover:visible group-hover:opacity-100 left-1/2 top-full mt-2 -translate-x-1/2 false false false">
                    X
                  </p>
                </div>
              </a>
              <a target="_blank" rel="noreferrer" href="https://instagram.com/">
                <div className="group relative inline-block">
                  <img
                    alt="Instagram"
                    loading="lazy"
                    width={48}
                    height={48}
                    decoding="async"
                    data-nimg={1}
                    className="w-8"
                    style={{ color: "transparent" }}
                    src="../assets/img/social/instagram.svg"
                  />
                  <p className="invisible absolute whitespace-nowrap rounded-md bg-neutral-900 text-white p-2 text-xs opacity-0 shadow-sm duration-100 ease-linear group-hover:visible group-hover:opacity-100 left-1/2 top-full mt-2 -translate-x-1/2 false false false">
                    Instagram
                  </p>
                </div>
              </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id='about'>
        <div className="mb-9 animate-fade-left animate-once animate-ease-linear mt-80 max-w-[65rem] px-8 py-10 sm:px-6 lg:px-8 lg:py-14 md:mx-64 justify-content">
          <h2 className="text-4xl md:text-5xl md:text-6xl text-bold text-white flex container">
            About Me
          </h2>
          <p className="mt-2 mb-3 text-2xl bg-gradient-to-r from-pink-500 to-orange-500 text-transparent bg-clip-text">
            Building things through code
          </p>
          <p className="text-white text-[18px]">
          A passionate full-stack web developer with a keen interest in backend development. Currently pursuing my Bachelor of Technology in Computer Science and Engineering with a specialization in Cloud Computing and Automation at Vellore Institute of Technology (VIT), Bhopal, As an AWS Certified Solutions Architect Associate with comprehensive knowledge of AWS technologies, coupled with proficiency in the MERN Stack, I'm deeply committed to backend development. I'm actively seeking internship opportunities to further enhance my skills and contribute meaningfully to impactful projects.
          </p>
          <div className="my-5">
            <a href="/assets/resume.pdf">
            <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2"><i class="ri-download-2-line mr-2"></i> Resume</button>
            </a>
          </div>

        </div>
      </section>

      <section className="mt-20 max-w-[65rem] flex justify-center items-center px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h2 className="text-4xl md:text-5xl mx-1 text-white mb-16 my-6">
              Education
            </h2>

            <ol class="relative mx-4 border-s border-gray-200 null:border-gray-700">
              <li class="mb-16 ms-6">
                <span class="absolute flex items-center justify-center w-6 h-6 bg-white rounded-full -start-3 ring-8 ring-white null:ring-gray-900 null:bg-blue-900">
                  <img src="/assets/img/vit-logo.png" alt="vit-logo" />
                </span>
                <h3 class="flex items-center mb-1 text-lg font-semibold text-white ml-2">
                  Vellore Institute of Technology, Bhopal
                </h3>
                <p
                  style={{ color: "#B0B0B0	" }}
                  className="block mb-2 text-xs font-normal leading-none ml-2"
                >
                  <i class="ri-map-pin-fill mr-1"></i>Bhopal, India
                </p>
                <p class="block mb-2 text-sm font-normal leading-none ml-2 bg-gradient-to-r from-pink-500 to-orange-500 text-transparent bg-clip-text mt-2">
                  Bachelor of Technology in Computer Science Engineering
                </p>
                <p className="block  text-xs font-normal leading-none ml-2 bg-gradient-to-r from-pink-500 to-orange-500 text-transparent bg-clip-text">
                  Specialization in Cloud Computing and Automation
                </p>
                <span className="text-[10px] ml-2 text-gray-300">
                  2021 - 2025 (Expected)
                </span>
              </li>
              <li class="mb-10 ms-6">
                <span class="absolute flex items-center justify-center w-6 h-6 bg-white rounded-full -start-3 ring-8 ring-white null:ring-gray-900 null:bg-blue-900">
                  <img
                    src="/assets/img/st-arnold-log.jpeg"
                    alt="st-arnold-logo"
                  />
                </span>
                <h3 class="flex items-center mb-1 text-lg font-semibold text-white ml-2">
                  St. Arnold Higher Secondary School
                </h3>
                <p
                  style={{ color: "#B0B0B0	" }}
                  className="block mb-2 text-xs font-normal leading-none ml-2"
                >
                  <i class="ri-map-pin-fill mr-1"></i>Indore, India
                </p>
                <p class="block  text-sm font-normal leading-none ml-2 bg-gradient-to-r from-pink-500 to-orange-500 text-transparent bg-clip-text mt-2">
                  Higher Secondary School
                </p>
                <span className="text-[10px] ml-2 text-gray-300">
                  2006 - 2019
                </span>
              </li>
            </ol>
          </div>
          <div className="my-6">
            <h2 className="text-4xl md:text-5xl mx-1 text-white mt-16 md:mt-0 mb-16">
              Certifications
            </h2>

            <ol class="relative mx-4 border-s border-gray-200 null:border-gray-700">
              <li class="mb-16 ms-6">
                <span class="absolute flex items-center justify-center w-6 h-6 bg-white rounded-full -start-3 ring-8 ring-white null:ring-gray-900 null:bg-blue-900">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                  >
                    <path
                      fill="#252f3e"
                      d="M13.527,21.529c0,0.597,0.064,1.08,0.176,1.435c0.128,0.355,0.287,0.742,0.511,1.161 c0.08,0.129,0.112,0.258,0.112,0.371c0,0.161-0.096,0.322-0.303,0.484l-1.006,0.677c-0.144,0.097-0.287,0.145-0.415,0.145 c-0.16,0-0.319-0.081-0.479-0.226c-0.224-0.242-0.415-0.5-0.575-0.758c-0.16-0.274-0.319-0.58-0.495-0.951 c-1.245,1.483-2.81,2.225-4.694,2.225c-1.341,0-2.411-0.387-3.193-1.161s-1.181-1.806-1.181-3.096c0-1.37,0.479-2.483,1.453-3.321 s2.267-1.258,3.911-1.258c0.543,0,1.102,0.048,1.692,0.129s1.197,0.21,1.836,0.355v-1.177c0-1.225-0.255-2.08-0.75-2.58 c-0.511-0.5-1.373-0.742-2.602-0.742c-0.559,0-1.133,0.064-1.724,0.21c-0.591,0.145-1.165,0.322-1.724,0.548 c-0.255,0.113-0.447,0.177-0.559,0.21c-0.112,0.032-0.192,0.048-0.255,0.048c-0.224,0-0.335-0.161-0.335-0.5v-0.79 c0-0.258,0.032-0.451,0.112-0.564c0.08-0.113,0.224-0.226,0.447-0.339c0.559-0.29,1.229-0.532,2.012-0.726 c0.782-0.21,1.612-0.306,2.49-0.306c1.9,0,3.289,0.435,4.183,1.306c0.878,0.871,1.325,2.193,1.325,3.966v5.224H13.527z M7.045,23.979c0.527,0,1.07-0.097,1.644-0.29c0.575-0.193,1.086-0.548,1.517-1.032c0.255-0.306,0.447-0.645,0.543-1.032 c0.096-0.387,0.16-0.855,0.16-1.403v-0.677c-0.463-0.113-0.958-0.21-1.469-0.274c-0.511-0.064-1.006-0.097-1.501-0.097 c-1.07,0-1.852,0.21-2.379,0.645s-0.782,1.048-0.782,1.854c0,0.758,0.192,1.322,0.591,1.709 C5.752,23.786,6.311,23.979,7.045,23.979z M19.865,25.721c-0.287,0-0.479-0.048-0.607-0.161c-0.128-0.097-0.239-0.322-0.335-0.629 l-3.752-12.463c-0.096-0.322-0.144-0.532-0.144-0.645c0-0.258,0.128-0.403,0.383-0.403h1.565c0.303,0,0.511,0.048,0.623,0.161 c0.128,0.097,0.223,0.322,0.319,0.629l2.682,10.674l2.49-10.674c0.08-0.322,0.176-0.532,0.303-0.629 c0.128-0.097,0.351-0.161,0.639-0.161h1.277c0.303,0,0.511,0.048,0.639,0.161c0.128,0.097,0.239,0.322,0.303,0.629l2.522,10.803 l2.762-10.803c0.096-0.322,0.208-0.532,0.319-0.629c0.128-0.097,0.335-0.161,0.623-0.161h1.485c0.255,0,0.399,0.129,0.399,0.403 c0,0.081-0.016,0.161-0.032,0.258s-0.048,0.226-0.112,0.403l-3.847,12.463c-0.096,0.322-0.208,0.532-0.335,0.629 s-0.335,0.161-0.607,0.161h-1.373c-0.303,0-0.511-0.048-0.639-0.161c-0.128-0.113-0.239-0.322-0.303-0.645l-2.474-10.4 L22.18,24.915c-0.08,0.322-0.176,0.532-0.303,0.645c-0.128,0.113-0.351,0.161-0.639,0.161H19.865z M40.379,26.156 c-0.83,0-1.66-0.097-2.458-0.29c-0.798-0.193-1.421-0.403-1.836-0.645c-0.255-0.145-0.431-0.306-0.495-0.451 c-0.064-0.145-0.096-0.306-0.096-0.451v-0.822c0-0.339,0.128-0.5,0.367-0.5c0.096,0,0.192,0.016,0.287,0.048 c0.096,0.032,0.239,0.097,0.399,0.161c0.543,0.242,1.133,0.435,1.756,0.564c0.639,0.129,1.261,0.193,1.9,0.193 c1.006,0,1.788-0.177,2.331-0.532c0.543-0.355,0.83-0.871,0.83-1.532c0-0.451-0.144-0.822-0.431-1.129 c-0.287-0.306-0.83-0.58-1.612-0.838l-2.315-0.726c-1.165-0.371-2.027-0.919-2.554-1.645c-0.527-0.709-0.798-1.499-0.798-2.338 c0-0.677,0.144-1.274,0.431-1.79s0.671-0.967,1.149-1.322c0.479-0.371,1.022-0.645,1.66-0.838C39.533,11.081,40.203,11,40.906,11 c0.351,0,0.718,0.016,1.07,0.064c0.367,0.048,0.702,0.113,1.038,0.177c0.319,0.081,0.623,0.161,0.91,0.258s0.511,0.193,0.671,0.29 c0.224,0.129,0.383,0.258,0.479,0.403c0.096,0.129,0.144,0.306,0.144,0.532v0.758c0,0.339-0.128,0.516-0.367,0.516 c-0.128,0-0.335-0.064-0.607-0.193c-0.91-0.419-1.932-0.629-3.065-0.629c-0.91,0-1.628,0.145-2.123,0.451 c-0.495,0.306-0.75,0.774-0.75,1.435c0,0.451,0.16,0.838,0.479,1.145c0.319,0.306,0.91,0.613,1.756,0.887l2.267,0.726 c1.149,0.371,1.98,0.887,2.474,1.548s0.734,1.419,0.734,2.257c0,0.693-0.144,1.322-0.415,1.87 c-0.287,0.548-0.671,1.032-1.165,1.419c-0.495,0.403-1.086,0.693-1.772,0.903C41.943,26.043,41.193,26.156,40.379,26.156z"
                    ></path>
                    <path
                      fill="#f90"
                      d="M43.396,33.992c-5.252,3.918-12.883,5.998-19.445,5.998c-9.195,0-17.481-3.434-23.739-9.142 c-0.495-0.451-0.048-1.064,0.543-0.709c6.769,3.966,15.118,6.369,23.755,6.369c5.827,0,12.229-1.225,18.119-3.741 C43.508,32.364,44.258,33.347,43.396,33.992z M45.583,31.477c-0.671-0.871-4.438-0.419-6.146-0.21 c-0.511,0.064-0.591-0.387-0.128-0.726c3.001-2.128,7.934-1.516,8.509-0.806c0.575,0.726-0.16,5.708-2.969,8.094 c-0.431,0.371-0.846,0.177-0.655-0.306C44.833,35.927,46.254,32.331,45.583,31.477z"
                    ></path>
                  </svg>{" "}
                </span>
                <h3 class="flex items-center text-lg font-semibold text-white ml-2">
                  AWS Certified Solutions Architect - Associate
                </h3>
                <span className="text-[12px] ml-2 text-gray-300">Feb 2024</span>
                <p className="block mt-2 text-xs font-normal leading-none ml-2 bg-gradient-to-r from-pink-500 to-orange-500 text-transparent bg-clip-text">
                  <i class="ri-vip-diamond-fill mr-1"></i>Top Skills - EC2,
                  DynamoDB, EKS, ECS, SQS, Kinesis, Aurora{" "}
                </p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.credly.com/badges/16652e13-c05a-4790-8a04-0c2155346eb6"
                  className="block mt-2 ml-3 text-white hover:underline text-xs"
                >
                  <i class="ri-eye-line"></i> View
                </a>
              </li>
              <li class="mb-16 ms-6">
                <span class="absolute flex items-center justify-center w-6 h-6 bg-white rounded-full -start-3 ring-8 ring-white null:ring-gray-900 null:bg-blue-900">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                  >
                    <path
                      fill="#252f3e"
                      d="M13.527,21.529c0,0.597,0.064,1.08,0.176,1.435c0.128,0.355,0.287,0.742,0.511,1.161 c0.08,0.129,0.112,0.258,0.112,0.371c0,0.161-0.096,0.322-0.303,0.484l-1.006,0.677c-0.144,0.097-0.287,0.145-0.415,0.145 c-0.16,0-0.319-0.081-0.479-0.226c-0.224-0.242-0.415-0.5-0.575-0.758c-0.16-0.274-0.319-0.58-0.495-0.951 c-1.245,1.483-2.81,2.225-4.694,2.225c-1.341,0-2.411-0.387-3.193-1.161s-1.181-1.806-1.181-3.096c0-1.37,0.479-2.483,1.453-3.321 s2.267-1.258,3.911-1.258c0.543,0,1.102,0.048,1.692,0.129s1.197,0.21,1.836,0.355v-1.177c0-1.225-0.255-2.08-0.75-2.58 c-0.511-0.5-1.373-0.742-2.602-0.742c-0.559,0-1.133,0.064-1.724,0.21c-0.591,0.145-1.165,0.322-1.724,0.548 c-0.255,0.113-0.447,0.177-0.559,0.21c-0.112,0.032-0.192,0.048-0.255,0.048c-0.224,0-0.335-0.161-0.335-0.5v-0.79 c0-0.258,0.032-0.451,0.112-0.564c0.08-0.113,0.224-0.226,0.447-0.339c0.559-0.29,1.229-0.532,2.012-0.726 c0.782-0.21,1.612-0.306,2.49-0.306c1.9,0,3.289,0.435,4.183,1.306c0.878,0.871,1.325,2.193,1.325,3.966v5.224H13.527z M7.045,23.979c0.527,0,1.07-0.097,1.644-0.29c0.575-0.193,1.086-0.548,1.517-1.032c0.255-0.306,0.447-0.645,0.543-1.032 c0.096-0.387,0.16-0.855,0.16-1.403v-0.677c-0.463-0.113-0.958-0.21-1.469-0.274c-0.511-0.064-1.006-0.097-1.501-0.097 c-1.07,0-1.852,0.21-2.379,0.645s-0.782,1.048-0.782,1.854c0,0.758,0.192,1.322,0.591,1.709 C5.752,23.786,6.311,23.979,7.045,23.979z M19.865,25.721c-0.287,0-0.479-0.048-0.607-0.161c-0.128-0.097-0.239-0.322-0.335-0.629 l-3.752-12.463c-0.096-0.322-0.144-0.532-0.144-0.645c0-0.258,0.128-0.403,0.383-0.403h1.565c0.303,0,0.511,0.048,0.623,0.161 c0.128,0.097,0.223,0.322,0.319,0.629l2.682,10.674l2.49-10.674c0.08-0.322,0.176-0.532,0.303-0.629 c0.128-0.097,0.351-0.161,0.639-0.161h1.277c0.303,0,0.511,0.048,0.639,0.161c0.128,0.097,0.239,0.322,0.303,0.629l2.522,10.803 l2.762-10.803c0.096-0.322,0.208-0.532,0.319-0.629c0.128-0.097,0.335-0.161,0.623-0.161h1.485c0.255,0,0.399,0.129,0.399,0.403 c0,0.081-0.016,0.161-0.032,0.258s-0.048,0.226-0.112,0.403l-3.847,12.463c-0.096,0.322-0.208,0.532-0.335,0.629 s-0.335,0.161-0.607,0.161h-1.373c-0.303,0-0.511-0.048-0.639-0.161c-0.128-0.113-0.239-0.322-0.303-0.645l-2.474-10.4 L22.18,24.915c-0.08,0.322-0.176,0.532-0.303,0.645c-0.128,0.113-0.351,0.161-0.639,0.161H19.865z M40.379,26.156 c-0.83,0-1.66-0.097-2.458-0.29c-0.798-0.193-1.421-0.403-1.836-0.645c-0.255-0.145-0.431-0.306-0.495-0.451 c-0.064-0.145-0.096-0.306-0.096-0.451v-0.822c0-0.339,0.128-0.5,0.367-0.5c0.096,0,0.192,0.016,0.287,0.048 c0.096,0.032,0.239,0.097,0.399,0.161c0.543,0.242,1.133,0.435,1.756,0.564c0.639,0.129,1.261,0.193,1.9,0.193 c1.006,0,1.788-0.177,2.331-0.532c0.543-0.355,0.83-0.871,0.83-1.532c0-0.451-0.144-0.822-0.431-1.129 c-0.287-0.306-0.83-0.58-1.612-0.838l-2.315-0.726c-1.165-0.371-2.027-0.919-2.554-1.645c-0.527-0.709-0.798-1.499-0.798-2.338 c0-0.677,0.144-1.274,0.431-1.79s0.671-0.967,1.149-1.322c0.479-0.371,1.022-0.645,1.66-0.838C39.533,11.081,40.203,11,40.906,11 c0.351,0,0.718,0.016,1.07,0.064c0.367,0.048,0.702,0.113,1.038,0.177c0.319,0.081,0.623,0.161,0.91,0.258s0.511,0.193,0.671,0.29 c0.224,0.129,0.383,0.258,0.479,0.403c0.096,0.129,0.144,0.306,0.144,0.532v0.758c0,0.339-0.128,0.516-0.367,0.516 c-0.128,0-0.335-0.064-0.607-0.193c-0.91-0.419-1.932-0.629-3.065-0.629c-0.91,0-1.628,0.145-2.123,0.451 c-0.495,0.306-0.75,0.774-0.75,1.435c0,0.451,0.16,0.838,0.479,1.145c0.319,0.306,0.91,0.613,1.756,0.887l2.267,0.726 c1.149,0.371,1.98,0.887,2.474,1.548s0.734,1.419,0.734,2.257c0,0.693-0.144,1.322-0.415,1.87 c-0.287,0.548-0.671,1.032-1.165,1.419c-0.495,0.403-1.086,0.693-1.772,0.903C41.943,26.043,41.193,26.156,40.379,26.156z"
                    ></path>
                    <path
                      fill="#f90"
                      d="M43.396,33.992c-5.252,3.918-12.883,5.998-19.445,5.998c-9.195,0-17.481-3.434-23.739-9.142 c-0.495-0.451-0.048-1.064,0.543-0.709c6.769,3.966,15.118,6.369,23.755,6.369c5.827,0,12.229-1.225,18.119-3.741 C43.508,32.364,44.258,33.347,43.396,33.992z M45.583,31.477c-0.671-0.871-4.438-0.419-6.146-0.21 c-0.511,0.064-0.591-0.387-0.128-0.726c3.001-2.128,7.934-1.516,8.509-0.806c0.575,0.726-0.16,5.708-2.969,8.094 c-0.431,0.371-0.846,0.177-0.655-0.306C44.833,35.927,46.254,32.331,45.583,31.477z"
                    ></path>
                  </svg>
                </span>

                <h3 class="flex items-center text-lg font-semibold text-white ml-2">
                  AWS Certified Cloud Practitioner
                </h3>
                <span className="text-[12px] ml-2 text-gray-300">Dec 2023</span>
                <p className="block mt-2 text-xs font-normal leading-none ml-2 bg-gradient-to-r from-pink-500 to-orange-500 text-transparent bg-clip-text">
                  <i class="ri-vip-diamond-fill mr-1"></i>Top Skills - S3, IAM,
                  VPC, Cloudfront, KMS, Route 53
                </p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.credly.com/badges/df522108-8347-474e-ae25-1a62127140aa/public_url"
                  className="block mt-2 ml-3 text-white hover:underline text-xs"
                >
                  <i class="ri-eye-line"></i> View
                </a>
              </li>

              <li class="mb-16 ms-6">
                <span class="absolute flex items-center justify-center w-6 h-6 bg-white rounded-full -start-3 ring-8 ring-white null:ring-gray-900 null:bg-blue-900">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                  >
                    <path
                      fill="#ef3a3a"
                      d="M5.5,22.875c0,0,8-6.125,9.75-12.5c1.5-2.75,3.5-1.625,3.5-1.625s2.25,1,1.75,4.125 S14.75,31,17.875,33s8.922-14.062,12.25-18.5C32,12,34.5,13.25,35.25,15.625s0.625,11,0.625,11s0.375,4.125,3.25,1.75 S42,25.5,43,27.25s-1.75,5-3.375,5.875s-5.125,1.625-7.875-0.75s-2.5-7.5-2.5-7.5s-3.75,9.625-8,12.375s-10.407,3.147-10.875-2.625 C10,30,11,24.25,11,24.25S10,27,7,26C5.617,25.539,5.5,22.875,5.5,22.875z"
                    ></path>
                    <path
                      fill="#37474f"
                      d="M15.877,40.108c-0.753,0-1.5-0.116-2.206-0.357c-2.211-0.756-3.594-2.609-3.795-5.086 c-0.271-3.347-0.085-6.66,0.039-8.249c-0.8,0.312-2.075,0.472-3.673-0.487c-1.514-0.908-1.25-3.03-1.238-3.12l0.027-0.204 l0.164-0.126c0.069-0.053,6.922-5.377,9.588-12.283c0.618-1.142,1.36-1.817,2.234-2.068c1.073-0.309,1.941,0.166,1.978,0.188 c0.858,0.379,2.442,1.867,1.999,4.64c-0.123,0.769-0.508,2.173-0.995,3.952c-1.275,4.656-3.928,14.346-1.854,15.673 c0.151,0.096,0.303,0.115,0.494,0.064c1.803-0.501,4.65-6.25,6.938-10.87c1.531-3.091,2.977-6.011,4.149-7.573 c0.888-1.185,2.013-1.726,3.167-1.531c1.251,0.213,2.363,1.314,2.834,2.806c0.39,1.234,0.501,3.64,0.618,6.187 c0.117,2.546,0.238,5.179,0.639,6.713c0.031,0.119,0.131,0.404,0.388,0.474c0.25,0.068,1.033,0.04,2.774-1.701 c0.66-0.661,1.389-0.994,2.054-0.923c0.495,0.049,0.926,0.315,1.215,0.749c0.346,0.519,0.426,1.163,0.238,1.916 c-0.47,1.886-2.525,3.994-3.792,4.677c-1.9,1.024-6.126,2.158-8.505-0.882c-1.448-1.85-2.006-4.479-2.221-6.255 c-1.242,2.467-3.845,7.138-7.516,11.158C20.146,39.2,17.985,40.108,15.877,40.108z M11.14,24.241l-0.143,1.313 c-0.005,0.045-0.49,4.509-0.124,9.03c0.169,2.091,1.278,3.589,3.122,4.22c2.313,0.791,5.146,0.014,6.886-1.892 c5.129-5.617,8.13-12.541,8.16-12.61l0.958-2.231L30,24.5c0,0.048,0.029,4.864,2.144,7.566c1.969,2.517,5.599,1.503,7.245,0.618 c1.052-0.566,2.904-2.467,3.296-4.038c0.117-0.468,0.083-0.845-0.1-1.119c-0.124-0.186-0.286-0.289-0.482-0.309 c-0.354-0.029-0.81,0.196-1.249,0.635c-1.575,1.574-2.801,2.22-3.743,1.959c-0.762-0.206-1.019-0.898-1.094-1.187 c-0.427-1.635-0.551-4.321-0.67-6.919c-0.109-2.37-0.222-4.821-0.572-5.932c-0.359-1.137-1.164-1.97-2.049-2.12 c-0.774-0.131-1.538,0.262-2.2,1.145c-1.117,1.489-2.543,4.369-4.052,7.417c-3.221,6.506-5.488,10.812-7.566,11.39 c-0.461,0.13-0.91,0.064-1.301-0.186c-2.487-1.592-0.743-8.845,1.429-16.779c0.46-1.68,0.857-3.131,0.972-3.846 c0.429-2.685-1.385-3.555-1.462-3.591c-0.197-0.104-1.648-0.803-2.855,1.409c-2.531,6.568-8.567,11.607-9.707,12.518 c-0.016,0.435,0.027,1.491,0.775,1.939c2.069,1.241,3.35,0.11,3.403,0.062L11.14,24.241z"
                    ></path>
                  </svg>
                </span>

                <h3 class="flex items-center mb-1 text-lg font-semibold text-white ml-2">
                  The Complete 2024 Web Development Bootcamp
                </h3>
                <span className="text-[12px] ml-2 text-gray-300">Jan 2024</span>
                <p className="block mt-2 text-xs font-normal leading-none ml-2 bg-gradient-to-r from-pink-500 to-orange-500 text-transparent bg-clip-text">
                  <i class="ri-vip-diamond-fill mr-1"></i>Top Skills -
                  Javascript, Node.js, Express.js, MongoDB, React.js, REST APIs
                </p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.udemy.com/certificate/UC-73073573-4878-4375-adee-21e3a305ac33/"
                  className="block mt-2 ml-3 text-white hover:underline text-xs"
                >
                  <i class="ri-eye-line"></i> View
                </a>
              </li>
            </ol>
          </div>
        </div>
      </section>

      <section id="techstack">
        <div className="mb-9 mt-20 max-w-[85rem] md:max-w-[65rem] px-8 py-10 sm:px-6 lg:px-8 lg:py-14 md:mx-64 justify-content">
          <h2 className="text-4xl md:text-5xl text-bold text-white flex container">
            Tech Stack
          </h2>
          <h5 className="text-2xl ml-2 mt-2 mb-5 text-bold text-white">
            Technologies I Love ❤️
          </h5>
          <div className="my-5">
            <div className="flex flex-wrap">
              {skills.map((skill, index) => (
                <button
                  key={index}
                  type="button"
                  className="text-white bg-neutral-900 m-1 border border-neutral-900 hover:border-orange-700	 font-medium rounded-lg text-xs md:text-sm px-3 md:px-5 py-2.5 me-2 mb-2 flex items-center"
                >
                  <img className="w-4 md:w-5 mr-2" src={skill.iconURL} alt="" />
                  {skill.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="md:max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
          <h2 className="text-4xl md:text-5xl ml-4 mb-2 text-bold text-white flex container">
            Featured Projects
          </h2>
          <p className="ml-4 mb-10 text-2xl bg-gradient-to-r from-pink-500 to-orange-500 text-transparent bg-clip-text">My Best Work</p>


          <div class="grid md:grid-cols-3 gap-6">
            <div class="rounded-lg mx-3 md:mx-0 shadow bg-neutral-900">
              <div className="m-3">
                <img
                  class="rounded-md"
                  src="../assets/img/project-ss/drc.webp"
                  alt=""
                />
              </div>
              <div class="p-5">
                <h5 class="mb-3 text-3xl font-bold tracking-tight text-white hover:bg-gradient-to-r from-pink-500 to-orange-500 hover:bg-clip-text hover:text-transparent">
                  DesiRacingCo
                </h5>
                <p class="mb-3 font-normal text-white">
                  A motorsport news website catering to the passionate community
                  of Indian motorsport enthusiasts.<br></br>
                  <a
                    href="/project/1"
                    className="bg-clip-text text-xs hover:underline hover:text-gray-400 text-transparent bg-gradient-to-r from-pink-500 to-orange-500"
                  >
                    Learn more
                  </a>
                </p>
                <a
                  href="https://github.com/NielRanawat/DRC" target="_blank" rel="noreferrer"
                  class="inline-flex mt-2 mr-2 items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg bg-gradient-to-r from-pink-500 to-orange-500  group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white"
                >
                  GitHub
                  <svg
                    className="ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="rgba(255,255,255,1)"
                  >
                    <path d="M12.001 2C6.47598 2 2.00098 6.475 2.00098 12C2.00098 16.425 4.86348 20.1625 8.83848 21.4875C9.33848 21.575 9.52598 21.275 9.52598 21.0125C9.52598 20.775 9.51348 19.9875 9.51348 19.15C7.00098 19.6125 6.35098 18.5375 6.15098 17.975C6.03848 17.6875 5.55098 16.8 5.12598 16.5625C4.77598 16.375 4.27598 15.9125 5.11348 15.9C5.90098 15.8875 6.46348 16.625 6.65098 16.925C7.55098 18.4375 8.98848 18.0125 9.56348 17.75C9.65098 17.1 9.91348 16.6625 10.201 16.4125C7.97598 16.1625 5.65098 15.3 5.65098 11.475C5.65098 10.3875 6.03848 9.4875 6.67598 8.7875C6.57598 8.5375 6.22598 7.5125 6.77598 6.1375C6.77598 6.1375 7.61348 5.875 9.52598 7.1625C10.326 6.9375 11.176 6.825 12.026 6.825C12.876 6.825 13.726 6.9375 14.526 7.1625C16.4385 5.8625 17.276 6.1375 17.276 6.1375C17.826 7.5125 17.476 8.5375 17.376 8.7875C18.0135 9.4875 18.401 10.375 18.401 11.475C18.401 15.3125 16.0635 16.1625 13.8385 16.4125C14.201 16.725 14.5135 17.325 14.5135 18.2625C14.5135 19.6 14.501 20.675 14.501 21.0125C14.501 21.275 14.6885 21.5875 15.1885 21.4875C19.259 20.1133 21.9999 16.2963 22.001 12C22.001 6.475 17.526 2 12.001 2Z"></path>
                  </svg>{" "}
                </a>
                <a
                  href="https://dub.sh/project-drc" target="_blank" rel="noreferrer"
                  class="inline-flex mt-2 mr-2 items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg bg-gradient-to-r from-pink-500 to-orange-500  group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white"
                >
                  Demo
                  <svg
                    className="ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="rgba(255,255,255,1)"
                  >
                    <path d="M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z"></path>
                  </svg>
                </a>
              </div>
            </div>

            <div class="rounded-lg mx-3 md:mx-0 shadow bg-neutral-900">
              <div className="m-3">
                <img
                  class="rounded-md"
                  src="../assets/img/project-ss/secure-vault.webp"
                  alt=""
                />
              </div>
              <div class="p-5">
                <h5 class="mb-3 text-3xl font-bold tracking-tight text-white hover:bg-gradient-to-r from-pink-500 to-orange-500 hover:bg-clip-text hover:text-transparent">
                  SecureVault
                </h5>
                <p class="mb-3 font-normal text-white">
                  Secure Vault can be used to store and manage important
                  documents and files in the cloud using AWS S3.
                  <br />
                  <a
                    href="/project/3"
                    className="bg-clip-text text-xs hover:underline hover:text-gray-400 text-transparent bg-gradient-to-r from-pink-500 to-orange-500"
                  >
                    Learn more
                  </a>
                </p>
                <a
                  href="https://github.com/Ashish4793/secure-vault" target="_blank" rel="noreferrer"
                  class="inline-flex mt-2 mr-2 items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg bg-gradient-to-r from-pink-500 to-orange-500  group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white"
                >
                  GitHub
                  <svg
                    className="ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="rgba(255,255,255,1)"
                  >
                    <path d="M12.001 2C6.47598 2 2.00098 6.475 2.00098 12C2.00098 16.425 4.86348 20.1625 8.83848 21.4875C9.33848 21.575 9.52598 21.275 9.52598 21.0125C9.52598 20.775 9.51348 19.9875 9.51348 19.15C7.00098 19.6125 6.35098 18.5375 6.15098 17.975C6.03848 17.6875 5.55098 16.8 5.12598 16.5625C4.77598 16.375 4.27598 15.9125 5.11348 15.9C5.90098 15.8875 6.46348 16.625 6.65098 16.925C7.55098 18.4375 8.98848 18.0125 9.56348 17.75C9.65098 17.1 9.91348 16.6625 10.201 16.4125C7.97598 16.1625 5.65098 15.3 5.65098 11.475C5.65098 10.3875 6.03848 9.4875 6.67598 8.7875C6.57598 8.5375 6.22598 7.5125 6.77598 6.1375C6.77598 6.1375 7.61348 5.875 9.52598 7.1625C10.326 6.9375 11.176 6.825 12.026 6.825C12.876 6.825 13.726 6.9375 14.526 7.1625C16.4385 5.8625 17.276 6.1375 17.276 6.1375C17.826 7.5125 17.476 8.5375 17.376 8.7875C18.0135 9.4875 18.401 10.375 18.401 11.475C18.401 15.3125 16.0635 16.1625 13.8385 16.4125C14.201 16.725 14.5135 17.325 14.5135 18.2625C14.5135 19.6 14.501 20.675 14.501 21.0125C14.501 21.275 14.6885 21.5875 15.1885 21.4875C19.259 20.1133 21.9999 16.2963 22.001 12C22.001 6.475 17.526 2 12.001 2Z"></path>
                  </svg>{" "}
                </a>
                <a
                  href="https://dub.sh/url-redirect-secure-vault" target="_blank" rel="noreferrer"
                  class="inline-flex mt-2 mr-2 items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg bg-gradient-to-r from-pink-500 to-orange-500  group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white"
                >
                  Demo
                  <svg
                    className="ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="rgba(255,255,255,1)"
                  >
                    <path d="M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z"></path>
                  </svg>
                </a>
              </div>
            </div>

            <div class="rounded-lg mx-3 md:mx-0 shadow bg-neutral-900">
              <div className="m-3">
                <img
                  class="rounded-md"
                  src="../assets/img/project-ss/streamscan.webp"
                  alt=""
                />
              </div>
              <div class="p-5">
                <h5 class="mb-3 text-3xl font-bold tracking-tight text-white hover:bg-gradient-to-r from-pink-500 to-orange-500 hover:bg-clip-text hover:text-transparent">
                  StreamScan
                </h5>
                <p class="mb-3 font-normal text-white">
                  StreamScan is your go-to solution for discovering the
                  streaming availability of movies and <br></br> TV shows.
                  <br></br>
                  <a
                    href="/project/6"
                    className="bg-clip-text text-xs hover:underline hover:text-gray-400 text-transparent bg-gradient-to-r from-pink-500 to-orange-500"
                  >
                    Learn more
                  </a>
                </p>
                <a
                  href="https://github.com/Ashish4793/streamscan" target="_blank" rel="noreferrer"
                  class="inline-flex mt-2 mr-2 items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg bg-gradient-to-r from-pink-500 to-orange-500  group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white"
                >
                  GitHub
                  <svg
                    className="ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="rgba(255,255,255,1)"
                  >
                    <path d="M12.001 2C6.47598 2 2.00098 6.475 2.00098 12C2.00098 16.425 4.86348 20.1625 8.83848 21.4875C9.33848 21.575 9.52598 21.275 9.52598 21.0125C9.52598 20.775 9.51348 19.9875 9.51348 19.15C7.00098 19.6125 6.35098 18.5375 6.15098 17.975C6.03848 17.6875 5.55098 16.8 5.12598 16.5625C4.77598 16.375 4.27598 15.9125 5.11348 15.9C5.90098 15.8875 6.46348 16.625 6.65098 16.925C7.55098 18.4375 8.98848 18.0125 9.56348 17.75C9.65098 17.1 9.91348 16.6625 10.201 16.4125C7.97598 16.1625 5.65098 15.3 5.65098 11.475C5.65098 10.3875 6.03848 9.4875 6.67598 8.7875C6.57598 8.5375 6.22598 7.5125 6.77598 6.1375C6.77598 6.1375 7.61348 5.875 9.52598 7.1625C10.326 6.9375 11.176 6.825 12.026 6.825C12.876 6.825 13.726 6.9375 14.526 7.1625C16.4385 5.8625 17.276 6.1375 17.276 6.1375C17.826 7.5125 17.476 8.5375 17.376 8.7875C18.0135 9.4875 18.401 10.375 18.401 11.475C18.401 15.3125 16.0635 16.1625 13.8385 16.4125C14.201 16.725 14.5135 17.325 14.5135 18.2625C14.5135 19.6 14.501 20.675 14.501 21.0125C14.501 21.275 14.6885 21.5875 15.1885 21.4875C19.259 20.1133 21.9999 16.2963 22.001 12C22.001 6.475 17.526 2 12.001 2Z"></path>
                  </svg>{" "}
                </a>
                <a
                  href="https://streamscan.netlify.com/" target="_blank" rel="noreferrer"
                  class="inline-flex mt-2 mr-2 items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg bg-gradient-to-r from-pink-500 to-orange-500  group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white"
                >
                  Demo
                  <svg
                    className="ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="rgba(255,255,255,1)"
                  >
                    <path d="M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div class="mt-12 text-center">
            <a href="/projects">
              <button class="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-pink-500 to-orange-400 group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white focus:ring-4 focus:outline-none focus:ring-pink-200">
                <span class="relative px-5 py-2.5 transition-all ease-in duration-75 text-white rounded-md group-hover:bg-opacity-0">
                  All projects <i class="ri-arrow-right-line"></i>
                </span>
              </button>
            </a>
          </div>
        </div>
      </section>

      <Footer />

    </div>
  );
}

export default App;
